import { Appointment } from '@weave/schema-gen-ts/dist/schemas/schedule/calendar-events/v1/calendar_events.pb';
import { Provider } from '@weave/schema-gen-ts/dist/schemas/schedule/settings/v2/settings.pb';
import { CalendarEvent } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/calendar_event.pb';
import { Practitioner } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/practitioner.pb';
import { ContactType_Enum } from '@weave/schema-gen-ts/dist/shared/persons/v3/enums.pb';
import dayjs from 'dayjs';
import { formatDateTime } from '../../utils/date-helpers';

const getAppointmentDate = (event: CalendarEvent, timezone: string) => {
  return formatDateTime(`${event.startDate} ${event.startTime}`, {
    fromTimezone: 'UTC',
    toTimezone: timezone,
  });
};

export const convertV3CalendarEventToAppointmentDetails = (
  events: CalendarEvent[],
  locationTimezoneMap?: Record<string, string>
): Appointment[] => {
  return events.map((event: CalendarEvent) => {
    const locationId = event.locationId ?? '';
    return {
      id: event.id,
      locationIds: locationId ? [locationId] : [], // Revisit
      locationId: locationId,
      start: locationTimezoneMap?.[locationId]
        ? getAppointmentDate(event, locationTimezoneMap[locationId])
        : dayjs(`${event.startDate} ${event.startTime}`).toString(),
      // type: Previous code was using eventType as a fallback to populate the type field. EventType is not the appointment type. An appointment is created with the eventType set to 'APPOINTMENT'. type: event.details?.rTyNa === appointment type
      type: event.details?.rTyNa ?? '',
      appointmentTypeId: event.referenceTypeId ?? '',
      duration: event.details?.dur,
      externalStatus: event.attendeeStatus,
      practitionerName: event.details?.orNa,
      providerIds: event.organizerId ? [event.organizerId] : [],
      person: {
        firstName: event.attendeeDetails?.firstName,
        lastName: event.attendeeDetails?.lastName,
        preferredName: event.attendeeDetails?.preferredName,
        personId: event.attendeeDetails?.personId,
        gender: event.attendeeDetails?.gender,
        status: event.attendeeDetails?.status,
        birthDate: event.attendeeDetails?.birthdate,
        householdId: event.attendeeDetails?.householdId,
        mobilePhone: event.attendeeDetails?.contactInfo?.find(
          (contact) => contact.type === ContactType_Enum.PHONE_MOBILE
        )?.destination,
        homePhone: event.attendeeDetails?.contactInfo?.find((contact) => contact.type === ContactType_Enum.PHONE_HOME)
          ?.destination,
        workPhone: event.attendeeDetails?.contactInfo?.find((contact) => contact.type === ContactType_Enum.PHONE_WORK)
          ?.destination,
      },
      createdBySourceId: event.sourceTenantId,
      workstationIds: event.operatoryId ? [event.operatoryId] : [],
      isNonIntegratedSource: !event.isIntegrated,
      statusOfficeView: event.attendeeStatus,
      referenceId: event.referenceId ?? '',
    };
  });
};

export const convertV3PractitionerToProvider = (practitioners: Practitioner[]): Provider[] => {
  return practitioners.map((practitioner: Practitioner) => {
    return {
      id: practitioner.id,
      firstName: practitioner.firstName,
      lastName: practitioner.lastName,
      publicDisplayName: practitioner.displayName || '',
      locationId: practitioner.locationId,
      resourceName: practitioner.externalName,
      externalId: practitioner.externalId,
      publicDisplayImage: practitioner?.profile?.picUrl,
      createdAt: practitioner.createdAt,
      updatedAt: practitioner.updatedAt,
      publicDisplayDescription: practitioner.profile?.bio || '',
      sourceId: practitioner.sourceTenantId,
    };
  });
};
